import { render, staticRenderFns } from "./InquiryAddress.vue?vue&type=template&id=53c46e00"
import script from "./InquiryAddress.vue?vue&type=script&lang=js"
export * from "./InquiryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports